import { ChevronDown, Plus } from 'lucide-react'
import { Link } from 'react-router'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

import { useSubscriptionCheck } from '@/hooks/useSubscriptionCheck'

import { createTargets } from './nav-items'

interface CreateMenuProps {
  /** Kontextová akce stránky (invoice, order, expense, participant). Jde na první místo. */
  primary?: string
  features?: string[]
}

/** Jedno tlačítko Vytvořit pro celou aplikaci (Mercury/Runey vzor). */
export const CreateMenu = ({ primary, features }: CreateMenuProps) => {
  const isSia = useSubscriptionCheck()
  const items = createTargets.filter((i) => !i.feature || !features || features.includes(i.feature))
  const main = items.find((i) => i.id === primary)

  if (!isSia) return null

  return (
    <div className="flex items-center">
      {main ? (
        <Button asChild className="rounded-r-none max-sm:px-2.5">
          <Link to={main.href} aria-label={main.id === 'expense' ? 'Nový náklad' : main.id === 'participant' ? 'Nový kontakt' : `Nová ${main.label.toLowerCase()}`}>
            <Plus />
            <span className="hidden sm:inline">
              {main.id === 'expense' ? 'Nový náklad' : main.id === 'participant' ? 'Nový kontakt' : `Nová ${main.label.toLowerCase()}`}
            </span>
          </Link>
        </Button>
      ) : null}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button className={main ? 'rounded-l-none border-l border-white/15 px-2' : ''} aria-label="Vytvořit">
            {!main && (
              <>
                <Plus />
                <span className="hidden sm:inline">Vytvořit</span>
              </>
            )}
            <ChevronDown className="opacity-70" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-52">
          <DropdownMenuLabel className="text-[11px] font-medium uppercase tracking-[0.06em] text-muted-foreground">Vytvořit</DropdownMenuLabel>
          <DropdownMenuSeparator />
          {items.map((item) => (
            <DropdownMenuItem key={item.id} asChild>
              <Link to={item.href}>
                <item.icon className="size-4" />
                {item.label}
              </Link>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
